import{deepClone}from"./clone.js";
import{getPluginOpts}from"./get.js";
import{mergeMethodOpts}from"./method.js";

































export const finalizePluginsOpts=({
pluginsOpts,
methodOpts,
plugins,
plugin
})=>{
const pluginsOptsA=mergeMethodOpts(pluginsOpts,methodOpts,plugins);
const pluginsOptsB=deepClone(pluginsOptsA);
const options=getPluginOpts({
pluginsOpts:pluginsOptsB,
plugin,
full:true
});
return options
};